export default __webpack_public_path__ + "static/media/COSTAL20.124f342e.png";